module.exports = __webpack_public_path__ + "img/A1F1_new.ddb6a70a.jpg";